import React from 'react';
import { Box, Typography, Container, IconButton, Divider, Link, Grid } from '@mui/material';
import { images } from '../assets/images';
import { gradients } from '../theme';

const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#0a0a0a',
        pt: 10,
        pb: 4,
        borderTop: '1px solid #222',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          {/* Brand Column */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box
              component="img"
              src={images.logo}
              alt="Bluecat"
              sx={{
                height: 50,
                width: 'auto',
                mb: 3,
              }}
            />
            <Typography
              sx={{
                color: '#9A9A9A',
                fontSize: 16,
                lineHeight: 1.6,
                mb: 4,
                maxWidth: 300,
              }}
            >
              Unlocking value from used catalytic converters through accurate analysis and transparent recycling.
            </Typography>

            {/* Social Icons */}
            <Box sx={{ display: 'flex', gap: 2 }}>
              {[images.socialFacebook, images.socialTwitter, images.socialLinkedin].map((icon, index) => (
                <IconButton
                  key={index}
                  sx={{
                    p: 1.5,
                    backgroundColor: 'rgba(255,255,255,0.05)',
                    '&:hover': {
                      backgroundColor: 'rgba(255,255,255,0.1)',
                      transform: 'translateY(-2px)',
                    },
                    transition: 'all 0.3s ease',
                  }}
                >
                  <Box
                    component="img"
                    src={icon}
                    alt="Social"
                    sx={{ width: 20, height: 20 }}
                  />
                </IconButton>
              ))}
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography variant="h6" sx={{ color: 'white', mb: 3, fontWeight: 600 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {['Home', 'About Us', 'Services', 'Contact Us'].map((item) => (
                <Link
                  key={item}
                  href={`#${item.toLowerCase().replace(' ', '')}`}
                  underline="none"
                  sx={{
                    color: '#9A9A9A',
                    fontSize: 16,
                    '&:hover': {
                      color: gradients.primary, // Using gradient might not work on text color directly without sx magic, fallback to white or primary
                      background: gradients.primary,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    },
                    transition: 'all 0.3s ease',
                  }}
                >
                  {item}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid size={{ xs: 12, sm: 6, md: 5 }}>
            <Typography variant="h6" sx={{ color: 'white', mb: 3, fontWeight: 600 }}>
              Contact Details
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              <Box>
                <Typography sx={{ color: 'white', fontSize: 14, fontWeight: 600, mb: 0.5 }}>
                  Address
                </Typography>
                <Typography sx={{ color: '#9A9A9A', fontSize: 14, lineHeight: 1.6 }}>
                  Warehouse No.5, Industrial area 12,<br />
                  Beside GECO Building, Sharjah - UAE
                </Typography>
              </Box>

              <Box>
                <Typography sx={{ color: 'white', fontSize: 14, fontWeight: 600, mb: 0.5 }}>
                  Mobile
                </Typography>
                <Typography sx={{ color: '#9A9A9A', fontSize: 14 }}>
                  054 461 1878
                </Typography>
              </Box>

              <Box>
                <Typography sx={{ color: 'white', fontSize: 14, fontWeight: 600, mb: 0.5 }}>
                  Tel
                </Typography>
                <Typography sx={{ color: '#9A9A9A', fontSize: 14 }}>
                  06 715 1943
                </Typography>
              </Box>

              <Box>
                <Typography sx={{ color: 'white', fontSize: 14, fontWeight: 600, mb: 0.5 }}>
                  Email
                </Typography>
                <Typography
                  component="a"
                  href="mailto:info@bluecatrecycling.com"
                  sx={{
                    color: '#9A9A9A',
                    fontSize: 14,
                    textDecoration: 'none',
                    '&:hover': { color: 'white' }
                  }}
                >
                  info@bluecatrecycling.com
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 6, borderColor: 'rgba(255,255,255,0.1)' }} />

        {/* Bottom Footer */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography sx={{ color: '#666', fontSize: 14 }}>
            © Copyright 2026 Bluecat Recycling. All Rights Reserved.
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ color: '#666', fontSize: 14 }}>
              Designed and developed by
            </Typography>
            <Box
              component="img"
              src={images.footerLogo}
              alt="Developer"
              sx={{ height: 20, width: 'auto', opacity: 0.7 }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
